import { Box, CircularProgress } from '@material-ui/core';
import { getNaturalPersonRiskExternalByDocumentNumber, Loan } from '@nemuru-eng/js-api-client';

import NaturalPersonRiskScoring from '@/components/shared/components/ConditionsSummary/LoanConditionsSummary/components/LenderApplications/components/RiskScoring/components/NaturalPersonRiskScoring';
import { Font } from '@/components/shared/components/Font';
import { PendingDataWarning } from '@/components/shared/components/PendingDataWarning';
import { Text } from '@/components/shared/components/Text';
import { PendingDataType } from '@/config/types';
import { usePageContext } from '@/contexts/PageContext/PageContext';
import { useCache } from '@/hooks/requests/useCache';
import { findCurrentParticipantOnboardingDetailsByOnboardingDetailsId } from '@/utils/findCurrentParticipantOnboardingDetails';

interface RiskScoringProps {
  loan: Loan;
}

export const RiskScoring = ({ loan }: RiskScoringProps) => {
  const {
    state: { applicationParticipant },
  } = usePageContext();

  const currentOnboardingDetails = findCurrentParticipantOnboardingDetailsByOnboardingDetailsId({
    loan: loan,
    onboardingDetailsId: applicationParticipant.onboardingDetails?.id,
  });

  const naturalPersonRisk =
    currentOnboardingDetails &&
    'userDetails' in currentOnboardingDetails &&
    currentOnboardingDetails.userDetails?.documentId.documentNumber
      ? useCache(getNaturalPersonRiskExternalByDocumentNumber, {
          documentNumber: currentOnboardingDetails.userDetails?.documentId.documentNumber,
        })
      : undefined;

  return (
    <>
      <Box pt={5}>
        <Font variant="subtitle1" color="textPrimary">
          <Text strong tId={'RISK_ANALYSIS'} />
        </Font>
        <Box pt={3}>
          {naturalPersonRisk?.loading ? (
            <Box display={'flex'} flexDirection={'row'}>
              <CircularProgress size={20} color={'secondary'} />
              <Font variant={'body2'} style={{ paddingLeft: '6px' }}>
                <Text tId={'LOADING'} />
              </Font>
            </Box>
          ) : naturalPersonRisk?.data && naturalPersonRisk.data.length > 0 ? (
            <NaturalPersonRiskScoring naturalPersonRisk={naturalPersonRisk.data} />
          ) : (
            <PendingDataWarning type={PendingDataType.RISK_ANALYSIS} />
          )}
        </Box>
      </Box>
    </>
  );
};
